import { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import PageLoader from "./component/PageLoader";
import { retrieveFromLocal } from "./helper/localStore";
import Language from "./page/Language";
import Avatar from "./page/Avatar";
import ClientUserUsage from "./page/ClientUserUsage";
import InstantClonedVoice from "./page/InstantClonedVoice";
import SttModelLanguage from "./page/SttModelLanguage";
import InstantSpeakerLanguage from "./page/InstantSpeakerLanguage";
import Api from "./page/Api";
import TTSEmotionConfig from "./page/TTSEmotionConfig";
// import Chatbot from "./page/Chatbot";

const Login = lazy(() => import("./page/Login"));
const Clients = lazy(() => import("./page/Clients"));
const Users = lazy(() => import("./page/Users"));
const ClientPermission = lazy(() => import("./page/ClientPermission"));
const ClientFeatureUsages = lazy(() => import("./page/ClientFeatureUsages"));
const ReportedIssue = lazy(() => import("./page/ReportedIssue"));
const UserPermission = lazy(() => import("./page/UserPermission"));
const UserFeatureUsages = lazy(() => import("./page/UserFeatureUsages"));
const NotFound = lazy(() => import("./page/NotFound"));

function App() {
  const token: any = retrieveFromLocal("token");
  const user: any = retrieveFromLocal("user");

  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<Login />} />

          {token ? (
            <>
              {!user && <Route path="/client" element={<Clients />} />}
              {!user && (
                <Route
                  path="/client/:id/permission"
                  element={<ClientPermission />}
                />
              )}
              {!user && <Route path="/language" element={<Language />} />}
              {!user && <Route path="/avatar" element={<Avatar />} />}
              {!user && (
                <Route
                  path="/stt-model-language"
                  element={<SttModelLanguage />}
                />
              )}
              {!user && (
                <Route
                  path="/instant-speaker-language"
                  element={<InstantSpeakerLanguage />}
                />
              )}
              {!user && (
                <Route
                  path="/tts-emotion-config"
                  element={<TTSEmotionConfig />}
                />
              )}
              {/*  {!user && <Route path="/chatbot" element={<Chatbot />} />} */}

              {/* {!user && <Route path="/avatar" element={<Avatar />} />} */}
              <Route path="/client/:id" element={<Users />} />
              <Route
                path="/client/:id/usages"
                element={<ClientFeatureUsages />}
              />
              <Route
                path="/client-user-usage/:id"
                element={<ClientUserUsage />}
              />
              <Route path="/client/:id/issues" element={<ReportedIssue />} />
              <Route path="/user/:id/permission" element={<UserPermission />} />
              <Route path="/user/:id/usages" element={<UserFeatureUsages />} />
              <Route
                path="/user/:id/instant-cloned-voice"
                element={<InstantClonedVoice />}
              />

              {/* api section */}
              <Route path="/user/:user_id/api" element={<Api />} />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/login" />} />
          )}

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
